import type { PostEnriched } from '@/lib/db/types';

/** Resolve combo course slug from round join or post metadata fallback. */
export function resolvePostCourseSlug(post: PostEnriched): string {
  return post.round?.course?.slug || post.metadata?.courseSlug || '';
}
